import React, { useState } from 'react';
import { Grid, Theme, Box, Typography, Button, Dialog, TextField } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { updateWorkspaceDesc } from '../../services/insightService';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(5),
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
    },
    title: { fontSize: '1.5rem', marginBottom: theme.spacing(4) },
    buttonSection: {
      marginTop: theme.spacing(4),
      display: 'flex',
      float: 'right',
    },
  }),
);

export default function ConfirmModal(props: {
  toggleModal: (boolean) => void;
  open: boolean;
  handleSave: () => Promise<void>;
}) {
  const classes = useStyles();

  const { toggleModal, open, handleSave } = props;
  const [workspaceDesc, setWorkspaceDesc] = useState<string>('');

  const handleCloseModal = () => {
    toggleModal(false);
  };

  const handleConfirm = async () => {
    await updateWorkspaceDesc({ short_desc: workspaceDesc });
    await handleSave();
    toggleModal(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth={'sm'}>
        <Grid container className={classes.root}>
          <Grid item lg={12}>
            <Typography variant={'h4'} mb={1}>
              Describe Your Organization
            </Typography>
            <TextField
              fullWidth
              placeholder="Please tell us about your organization in up to 10 sentences. We will use this information to inform our AI models."
              onChange={e => {
                setWorkspaceDesc(e.target.value);
              }}
              multiline={true}
            />
            <Box className={classes.buttonSection}>
              <Button variant="outlined" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button variant="contained" style={{ marginLeft: 10 }} onClick={handleConfirm}>
                Save Changes
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
